<template>
	<div class="popUp" v-if="show" :style="tmpTheme">
		<div class="mask" @click="closePop"></div>
		<div class="SliderVerify">
			<div class="title">安全验证</div>
			<slide-verify
				:l="42"
				:r="10"
				:w="310"
				:h="155"
				:imgs="picArray"
				:show="false"
				slider-text="向右滑动完成验证"
				ref="slideverify"
				@success="onSuccess"
				@fail="onFail"
				@refresh="onRefresh"
			></slide-verify>
		</div>
	</div>
</template>
  
<script>
export default { 
	name: "SliderVerify",
	props:{
		show:{
			type:Boolean,
			default:false
		}
	},
	data() { 
		return {
			// show:{},
			//在data中引入`assets`中的图片可以通过`require`的方式来引入
			picArray: [
				require("@/assets/img/codeimg.png"),
				// require("@/assets/img/bannercot01.png"),
			],
		};
	},
	computed: {
		tmpTheme() {
			return {
				'--bgColor': this.$store.state.sysConfig.colorConfig.bgColor,
				'--fontColor': this.$store.state.sysConfig.colorConfig.fontColor
			};
		}
	},
	methods: { 
		
		onSuccess() { 
		//往父级传递验证通过的函数
			this.$emit("success",true);
		},
		closePop(){
			// this.show = false
			this.$emit("success",false);
		},
		onReset() { 
		//重置图片验证组件
			this.$refs.slideverify.reset();
		},
		onFail() { 
		},
		onRefresh() { 
		},
	},
};
</script>
<style scoped lang="scss">
	.popUp {
		z-index: 2100;
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		.mask {
			width: 100%;
			height: 100%;
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-color: #000;
			opacity: 0.3;
		}
	}
	.SliderVerify {
		position: relative;
		width: 330px;
		top: 33%;
    left: 50%;
    transform: translateX(-50%);
		background-color: #fff;
    padding: 10px;
    border-radius: 5px;
		box-sizing: border-box;
		.title {
			text-align: center;
			padding: 0 0 5px 0;
			color: #666;
		}
	}
	:deep .slide-verify-slider-mask-item:hover {
    background: var(--bgColor,#1991fa) !important;
	}
	:deep .slide-verify-slider-mask-item{
		border: 1px solid var(--bgColor,#1991fa) !important;
	}
	:deep .slide-verify-slider-mask-item {
		background: var(--bgColor,#1991fa) !important;
	}
	:deep .slide-verify-slider-mask {
		border: 0 solid var(--bgColor,#1991fa) !important;
		background: var(--bgColor,#1991fa) !important;
	}
	:deep .container-success .slide-verify-slider-mask-item {
		background: var(--bgColor, #1991fa) !important;
	}
	:deep .SliderVerify .container-fail .slide-verify-slider-mask-item {
		background: var(--bgColor, #1991fa) !important;
	}
	:deep .SliderVerify .container-success .slide-verify-slider-mask-item {
		background: var(--bgColor, #1991fa) !important;
	}

</style>